// Форматирование/группировка дат мероприятий.

export const formatEventTime = (dateTimeStr) => {
    if (!dateTimeStr) return null;
    return new Date(dateTimeStr).toLocaleString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

const getDateKey = (dateTimeStr) => {
    if (!dateTimeStr) return 'no-date';
    const d = new Date(dateTimeStr);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const formatDayLabel = (dateKey) => {
    const d = new Date(dateKey);
    const weekday = d.toLocaleString('ru-RU', { weekday: 'long' });
    const month = d.toLocaleString('ru-RU', { month: 'long' });
    return `${weekday}, ${d.getDate()} ${month} ${d.getFullYear()} г.`;
};

// Группирует мероприятия по дню → [{ dateKey, dayLabel, events }] (по возрастанию).
export function groupEventsByDate(events) {
    const grouped = events.reduce((acc, event) => {
        const key = getDateKey(event.startTime);
        (acc[key] = acc[key] || []).push(event);
        return acc;
    }, {});

    return Object.entries(grouped)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([dateKey, dayEvents]) => ({
            dateKey,
            dayLabel: formatDayLabel(dateKey),
            events: [...dayEvents].sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
        }));
}
